export default __webpack_public_path__ + "static/media/Aneomi-1.8ebcc4b4.png";